/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSiteUserRoleDto } from '../../models/update-site-user-role-dto';

export interface SiteControllerUpdateUserSiteRole$Params {
  siteId: string;
  id: string;
      body: UpdateSiteUserRoleDto
}

export function siteControllerUpdateUserSiteRole(http: HttpClient, rootUrl: string, params: SiteControllerUpdateUserSiteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, siteControllerUpdateUserSiteRole.PATH, 'post');
  if (params) {
    rb.path('siteId', params.siteId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

siteControllerUpdateUserSiteRole.PATH = '/sites/{siteId}/users/{id}';
